import script from "./CustomerDistributionInfoEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDistributionInfoEdit.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDistributionInfoEdit.vue?vue&type=style&index=0&id=adfcf5b4&lang=scss"

const __exports__ = script;

export default __exports__